import { Injectable, Inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { Store } from '@ngrx/store';
import { AppState } from '../app.state';

import { SetKioskError } from './kiosk.actions';
import { KioskError } from './kiosk.reducer';

@Injectable()
export class KioskInterceptor implements HttpInterceptor {
  constructor(
    @Inject('$state') private $state,
    private store: Store<AppState>,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .catch((err: HttpErrorResponse) => {
        this.store.dispatch(new SetKioskError(KioskError.HttpError));
        return Observable.empty<HttpEvent<any>>();
      });
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk.interceptor.ts